<script setup lang="ts">
import { BadgeModel, MContainerGrow } from "@xlabmedical/medic-web-framework";

const tabMenuItems = defineModel<BadgeModel[]>("tabMenuItems", { required: true });
const tabIndex = defineModel("tabIndex", { required: true });
const disabled = defineModel("disabled", { required: false, default: false });
</script>

<template>
    <MContainerGrow class="rg-button-menu gap-4 pt-2">
        <Button
            v-for="(tabMenuItem, index) in tabMenuItems"
            :badge="tabMenuItem.badge?.toString()"
            :key="index"
            class="rg-button-menu__button"
            :class="{ 'p-button-outlined': tabIndex !== index }"
            :label="tabMenuItem.label"
            style="height: 56px; border-radius: 16px; border: 1px var(--p-rg-border-color) solid !important"
            :disabled="disabled"
            @click="tabIndex = index" />
    </MContainerGrow>
</template>

<style scoped>
.rg-button-menu {
    width: 100%;
}

@media (min-width: 1200px) {
    .rg-button-menu__button {
        min-width: 103px;
    }
}

@media (max-width: 900px) {
    .rg-button-menu {
        display: grid !important;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        align-items: stretch;
    }

    .rg-button-menu__button {
        width: 100%;
        min-width: 0;
    }

    :deep(.rg-button-menu__button .p-button-label) {
        white-space: normal;
        text-align: center;
        line-height: 1.1;
    }
}
</style>
